<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-indent:00em; padding-bottom:15px;">For my amazing daughter E, who gave me more reason and inspiration to write this book. I love you more than words can say, and I am incredibly proud to be your father.</p>
<p style="text-indent:00em; padding-bottom:15px;">A huge thank you to my mum, Sue, for keeping me focussed in everything I do. Love you lots Mum.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?401e79a2